<script>
  export let width = 24;
  export let height = 24;
  export let name = "";
  export let color = "currentColor";
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  {width}
  {height}
  viewBox="0 0 24 24"
  aria-labelledby={name}
  role="presentation"
  stroke={color}
  stroke-width="1.5"
  fill="none"
  class="w-6 h-6">
  <title id={name} lang="en">{`${name} icon`}</title>
  <slot />
</svg>
